import React from 'react';
import styled, { css } from 'styled-components';
import { sectionMargins, sectionPaddings, standardColours } from '../styles';
import CardSlider from './CardSlider';
import ProductCard from './ProductCard';

const StyledFeaturedProducts = styled.section`
  ${({ alt }) => {
    if (alt) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionPaddings()};
        background-color: ${standardColours.lightestGrey};
      `;
    }
  }}
`;

const FeaturedProducts = ({ heading, items, alt, ...props }) =>
  items.length > 0 && (
    <StyledFeaturedProducts alt={alt} {...props}>
      <CardSlider heading={heading} isFeaturedProducts={true}>
        {items.map((item, id) => (
          <ProductCard key={id} {...item} />
        ))}
      </CardSlider>
    </StyledFeaturedProducts>
  );

export default FeaturedProducts;
